import type { VoidFunctionComponent } from 'react';

import { Status } from '../../../../../shared/builds/types';
import { UNSAFE_HIDE_UNKNOWN_DEPS_BANNER_IN_REPORTS } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features/featureFlags';
import { useReleaseGroupDependenciesCount } from '../../../../hooks/api/releaseGroups/useReleaseGroupDependenciesCount';
import ProjectHasIssuesPanel from '../../overview/ProjectHasIssuesPanel';
import { UnknownDependenciesListItem } from '../../overview/UnknownDependenciesListItem';
import type { ReleaseGroupDetail } from '../../../../../shared/releaseGroups';

type Props = {
  projectGroup: ReleaseGroupDetail;
  releaseId: number;
  // Renders its own list wrapper, for states where there is no issues list to join.
  standalone?: boolean;
};

export const ReleaseGroupUnknownDependencies: VoidFunctionComponent<Props> = ({
  projectGroup,
  releaseId,
  standalone = false,
}) => {
  const isHiddenByConfig = useIsFeatureEnabled(UNSAFE_HIDE_UNKNOWN_DEPS_BANNER_IN_REPORTS);
  const { data } = useReleaseGroupDependenciesCount(
    projectGroup.id,
    releaseId,
    { status: [Status.Unknown] },
    !isHiddenByConfig,
  );
  const count = data?.count ?? 0;

  const item = (
    <UnknownDependenciesListItem
      key="unknown-dependencies"
      count={count}
      baseUrl={`/projects/group/${projectGroup.id}`}
      projectOrgId={projectGroup.organizationId}
    />
  );

  if (!standalone) {
    return item;
  }
  return count > 0 ? <ProjectHasIssuesPanel renderedIssues={[item]} /> : null;
};